/**
 * 2019/1/15
 * 作者:lzq
 *功能: 接口日志模块
 */
export default {
  $getway: 'sysapi',
  getPortLogList: 'portLog/list'
};
